import React, { useMemo, useState } from 'react';

export default function DataTable({
  columns,
  data,
  searchKeys = [],
  searchPlaceholder = 'Search…',
  pageSize = 10,
  emptyMessage = 'No records found',
  onRowClick,
  rowKey = 'id',
  getRowClassName,
}) {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);

  const filtered = useMemo(() => {
    if (!search.trim()) return data;
    const q = search.toLowerCase();
    return data.filter((row) =>
      searchKeys.some((k) => String(row[k] ?? '').toLowerCase().includes(q))
    );
  }, [data, search, searchKeys]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const paged = filtered.slice(page * pageSize, (page + 1) * pageSize);

  return (
    <div className="ui-data-table">
      {searchKeys.length > 0 && (
        <div className="ui-data-table-toolbar">
          <input
            type="search"
            placeholder={searchPlaceholder}
            value={search}
            onChange={(e) => { setSearch(e.target.value); setPage(0); }}
            className="ui-data-table-search"
          />
          <span className="ui-data-table-count">{filtered.length} records</span>
        </div>
      )}
      <div className="ui-data-table-wrap">
        <table>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paged.length === 0 ? (
              <tr><td colSpan={columns.length} className="ui-data-table-empty">{emptyMessage}</td></tr>
            ) : (
              paged.map((row) => (
                <tr
                  key={row[rowKey]}
                  onClick={() => onRowClick?.(row)}
                  className={[onRowClick ? 'is-clickable' : '', getRowClassName?.(row)].filter(Boolean).join(' ')}
                >
                  {columns.map((col) => (
                    <td key={col.key}>{col.render ? col.render(row) : row[col.key] ?? '—'}</td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {totalPages > 1 && (
        <div className="ui-data-table-pagination">
          <button type="button" disabled={page === 0} onClick={() => setPage((p) => p - 1)}>Prev</button>
          <span>Page {page + 1} of {totalPages}</span>
          <button type="button" disabled={page >= totalPages - 1} onClick={() => setPage((p) => p + 1)}>Next</button>
        </div>
      )}
    </div>
  );
}
